export const METRICS_STORE_KEY = 'metrics';
export const METRICS_SERVICE_KEY = 'metrics';
export const METRICS_API_URL = '/api/v1/metric/';
